import React, { Component } from 'react';

class InfoText extends Component {

    render() {
        if (this.props.message) {
            return (
                <div className="d-flex align-items-center py-2">
                    <div className="preview-thumbnail" >
                        <h2 className="color-primary4 h3 mdi mdi-information-outline" />
                    </div>
                    <div className="preview-item-content pl-3">
                        <h5 className="color-primary4 h5 font-weight-normal">{this.props.message}</h5>
                    </div>
                </div>
            );
        }
        else
            return (<div/>);
    }
}


export default InfoText;